import {useState, useEffect} from 'react'
import {camelizeKeys} from 'humps'

import {fetcher} from '~/api'

export const useRedemptionActivities = (supplierId) => {
  const [activities, setActivities] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!supplierId) {
      setLoading(false)
      return
    }

    const fetchActivities = async () => {
      try {
        setLoading(true)
        setError(null)

        const url = `/points/api/suppliers/${supplierId}/redemption_activities`

        const response = await fetcher(url)

        const processedData = camelizeKeys(response, {deep: true})
        setActivities(processedData.redemptionActivities || [])
        setTotal(processedData.redemptionsTotal || 0)
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchActivities()
  }, [supplierId])

  if (error) {
    throw error
  }

  return {
    activities,
    total,
    loading,
  }
}
